import { useEffect } from 'react';
import { usePageChromeSlot } from 'contexts/PageChromeContext';

/**
 * Name the screen in the bar at the top.
 *
 * `PageHeader` does this for pages that have one, but a page is not obliged
 * to — seven did not, and they showed an unnamed bar with no explanation of
 * what the screen was for. This is the same registration without the header.
 *
 * Both strings, so they compare equal and the effect settles. Cleared on
 * unmount, so the next screen does not wear this one's name.
 */
export default function usePageTitle(title, subtitle) {
  const { setTitle, setSubtitle } = usePageChromeSlot();

  useEffect(() => {
    if (typeof setTitle !== 'function') return undefined;
    setTitle(title || null);
    setSubtitle(subtitle || null);
    return () => { setTitle(null); setSubtitle(null); };
  }, [setTitle, setSubtitle, title, subtitle]);
}
